import * as types from './types';
import { SET_UNREAD_COUNT_NOTIFICATIONS, SET_NOTIFICATION_LIST, ADD_NEW_NOTIFICATION } from '../mutations/types';

export default {
  [types.SET_UNREAD_COUNT_NOTIFICATIONS]: ({ commit }, unreadCount) => {
    commit(SET_UNREAD_COUNT_NOTIFICATIONS, unreadCount);
  },

  [types.SET_NOTIFICATION_LIST]: ({ commit }, notificationList) => {
    commit(SET_NOTIFICATION_LIST, notificationList);
  },

  [types.ADD_NEW_NOTIFICATION]: ({ commit }, notification) => {
    commit(ADD_NEW_NOTIFICATION, notification);
  },

  [types.SET_DISTURB]: ({ commit }, isNotDisturb) => {
    commit(types.SET_DISTURB, isNotDisturb);
  },
};
